import React, {useEffect, useRef} from 'react';
import {mountManagerDashboard} from './nativeRuntime';

export default function ManagerNativeView({state, onSetting, onRefresh, onImportRequested, onError, onController}) {
  const host = useRef(null), handlers = useRef({});
  handlers.current = {onSetting,onRefresh,onImportRequested,onError,onController};
  const snapshot = state.snapshot;
  const scope = `${state.panel.id}:${snapshot.payload_sha256 || snapshot.source_fact_at}`;
  useEffect(() => {
    let controller;
    try {
      controller = mountManagerDashboard(host.current, {
        snapshot:snapshot.payload, settings:state.settings, editable:state.can_edit,
        groupTag:state.panel.group_filter?.tag,
        onSetting:(...args) => handlers.current.onSetting(...args),
        onRefresh:() => handlers.current.onRefresh(),
        onImportRequested:() => handlers.current.onImportRequested(),
      });
      handlers.current.onController(controller);
    } catch (error) {handlers.current.onError('Не удалось открыть панель. Перечитайте данные; сохранённый снимок не изменён.');}
    return () => {controller?.dispose();handlers.current.onController(null);};
    // A save/sidebar resize must not remount an edited form. Only a new
    // authorized snapshot, scope or revoked edit right rebuilds the component.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scope,state.can_edit]);
  return <div ref={host} className="manager-native" data-testid="manager-native" aria-label="Данные персональной панели"/>;
}
